import { PortableText } from "next-sanity";
import { HeroSectionType } from "@/components/features/hero";
import { components } from "./hero-block";

interface BasicHeroProps {
  data: HeroSectionType;
}

function BasicHero({ data }: BasicHeroProps) {
  const { title, subtitle } = data;

  return (
    <section className="space-y-8 bg-white relative">
      <div className="mx-auto flex flex-col items-center gap-6 font-outfit max-w-screen-2xl px-6 md:px-8 justify-center w-full">
        <div className="space-y-6 pt-20 md:pt-28 flex flex-col items-center justify-center">
          {title && <PortableText value={title} components={components} />}
          {subtitle && <PortableText value={subtitle} components={components} />}
        </div>
      </div>
    </section>
  );
}

export default BasicHero;

